module.exports = __webpack_public_path__ + "img/img (33).58fce105.png";